import XlsxPopulate from 'xlsx-populate'

const FILE_NAME = 'all-user-list'

export const DownloadListUsers = async (listData: any) => {
  let transformedData: any = []
  transformedData = listData.map((item: any) => [
    item?.ID,
    item?.name,
    item?.type,
    item?.group,
    item?.lastLogin,
    item?.createdBy,
    item?.createdDate,
    item?.status,
  ])

  const inputKeys = ['ID', 'User Name', 'Type', 'Group', 'Last Login Time', 'Created By', 'Created On', 'Status']

  XlsxPopulate.fromBlankAsync().then(async (workbook) => {
    const data: any = []
    data.push([...inputKeys])

    listData.map((item: any, index: number) => {
      data.push([...Object.values(item), ...transformedData[index]])
    })

    workbook.sheet(0)?.cell('A1')?.value(data)

    const blob = await workbook.outputAsync({
      type: 'blob',
    })

    var url = window.URL.createObjectURL(blob as Blob)
    var a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = `${FILE_NAME}.xlsx`
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  })
}
